<template>
    <rkm-modal
        ref="modal"
        title="Justificativa do cancelamento"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-form-textarea
                :validations="validations.justificativa"
                label="Justificativa"
                v-model="model.justificativa"
            />
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="cancelSolicitacao"
                color="primary"
                type="submit"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>
<script>

// Mixin.
import { repository } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
     computed: {
        validations() {
            return {
                justificativa: {
                    max: 300,
                    min: 3,
                    required: true,
                }
            }
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('manutencao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            id: null,
            justificativa: null,
        },
        enums: { statusTipo }
    }),
    methods: {

        open(item) {

            this.model.id = item.id
            this.model.justificativa = null
            this.$refs.modal.show()
        },
        cancelSolicitacao() {

            this.$refs.Form.validate()
                .then( validate => {

                    if (!validate) return

                    this.repositories.solicitacao.update(
                        this.model.id,
                        {
                            acao: 'cancelar',
                            status: this.enums.statusTipo.CANCELADO,
                            justificativa: this.model.justificativa
                        }
                    )
                    .then(() => {
                        this.showSaveNotification('Solicitação cancelada com sucesso!')
                        this.$emit('refresh')
                        this.$refs.modal.hide()
                    })
                    .catch(this.handleError)
                })
        },
    },
    mixins: [ repository ],
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>